import { useCreateLookalikePermitted } from './useCreateLookalikePermitted';
import { usePixelLookalikePermitted } from './usePixelLookalikePermitted';

export const useAudienceCreatorPixelPredictivePermissions = () => {
    const isCrmLookalikeAllowed = useCreateLookalikePermitted();
    const isPbpAllowed = usePixelLookalikePermitted();

    return {
        isPbpAllowed,
        isCrmLookalikeAllowed,
    };
};
